export default __webpack_public_path__ + "static/media/star-yellow.35a30513.svg";